<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel.loadingOpts$ | async"> </app-loading>

<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="'publish-collection'" [stickyZ]="9" [stickyOrder]="0">
    <div class="modal-header no-bottom-border pb-none">
      <div class="modal-title mb-28px">Publish Template Collection</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div
      class="publish-collection-sticky-info-container"
      libStickyAutoPosition
      [stickyCollectionKey]="'publish-collection'"
      [stickyZ]="9"
      [stickyOrder]="1">
      <ng-container [ngSwitch]="viewModel.collectionHasRequiredDisplays$ | async">
        <div *ngSwitchCase="false" class="info-text">
          <p>Are you sure you want to publish this?</p>
          <p>
            A published template collection can be used by any location. No required locations for this template
            collection have been set.
          </p>
        </div>

        <div *ngSwitchCase="true" class="info-text">
          Displays shown are set as Required Displays and will automatically deploy this template collection.
          <hr />
        </div>
      </ng-container>
    </div>
    <div class="publish-collection-location-container">
      <ng-container *ngIf="viewModel.numberOfProvinces$ | async as numberOfProvinces">
        <app-single-province-location-display-list-items
          *ngIf="numberOfProvinces === 1"
          [groupedRequiredDisplays]="viewModel.requiredDisplaysGroupedByLocationAndProvince$ | async">
        </app-single-province-location-display-list-items>

        <app-grouped-province-location-display-list-items
          *ngIf="numberOfProvinces > 1"
          [expanded]="true"
          [groupedRequiredDisplays]="viewModel.requiredDisplaysGroupedByLocationAndProvince$ | async">
        </app-grouped-province-location-display-list-items>
      </ng-container>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
      <lib-button-primary ngbAutofocus [style.margin-left]="'0.5rem'" (buttonClicked)="viewModel.publishCollection()">
        Publish Collection
      </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
